// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Zelv","alert":"SettungsInbox_alert__U8KC5"};